import { render, staticRenderFns } from "./DeclinedReasonSelect.vue?vue&type=template&id=67bc2d6f&scoped=true"
import script from "./DeclinedReasonSelect.vue?vue&type=script&lang=ts"
export * from "./DeclinedReasonSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bc2d6f",
  null
  
)

export default component.exports